import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/modal';
import { Button } from '@/components/ui/button';
import { ButtonLoadable } from '@/components/ui/button-loadable';
import { ModalProps } from '@/hooks/use-modal';

interface DeleteTimeEntryModalProps extends ModalProps {
  onConfirm: () => void;
  isLoading?: boolean;
}

export function DeleteTimeEntryModal({
  open,
  onOpen,
  onClose,
  onConfirm,
  isLoading,
}: DeleteTimeEntryModalProps) {
  const { t } = useTranslation('authenticated.timeTracking');

  return (
    <Modal open={open} onOpen={onOpen} onClose={onClose} className="max-w-lg">
      <Modal.Title className="mb-2">{t('modal.deleteEntry.title')}</Modal.Title>
      <Modal.Body className="mb-4 py-0 text-sm text-muted-foreground">
        {t('modal.deleteEntry.message')}
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            {t('modal.deleteEntry.cancel')}
          </Button>
          <ButtonLoadable variant="destructive" onClick={onConfirm} isLoading={isLoading}>
            {isLoading ? t('modal.deleteEntry.deleting') : t('modal.deleteEntry.confirm')}
          </ButtonLoadable>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
